import React from 'react';

const PartialNameRenderer = ({ rowData, columnData: { showOnlyFirstName } }) => {
  const { firstName, lastName } = rowData.employee || {};

  return <div>{showOnlyFirstName ? firstName : lastName}</div>;
};

export default PartialNameRenderer;
